import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Gallery, Item } from 'react-photoswipe-gallery';
import 'photoswipe/dist/photoswipe.css';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const CarouselGallery = ({ images }) => {
    return (
        <Gallery>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={10}
                slidesPerView={1}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }}
                navigation={{
                    enabled: window.innerWidth > 768, // Flechas solo en desktop
                }}
                pagination={{
                    clickable: true,
                }}
                autoplay={{ delay: 3000 }}
                loop
                style={{
                    paddingBottom: '50px', // Deja espacio suficiente para los puntos
                }}
            >

                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                    <div className="image-container" data-aos="zoom-in" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                      <Item
                        original={image.src}
                        thumbnail={image.src}
                        width="1024"
                        height="768"
                      >
                        {({ ref, open }) => (
                          <img
                            ref={ref}
                            onClick={open}
                            src={image.src}
                            alt={image.alt}
                            title={image.title}
                            className="d-block w-100"
                          />
                        )}
                      </Item>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
        </Gallery>
    );
};

export default CarouselGallery;






